import { Box, Button, Divider, Grid, IconButton, InputLabel, Modal, FormControl, MenuItem, Select, ThemeProvider, Typography } from "@mui/material";
import { CalenderTable } from "./CalenderTable";
import { darkTheme, style, theme } from "../../../styles/styles";
import { useCallback, useEffect, useState } from "react";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useGetLessonSessionsQuery } from "../../../api/lessonNoteApi";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import api from "../../../services/QualityAssurance"

export const Calender = () => {
    const { admToken } = useSelector((state) => state.auth);
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadindData] = useState(false);
    const [schoolYear, setSchoolYear] = useState({
        sessionId: 0,
        sessionName: ''
    });

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () =>  setOpenModal(false)
    const { data: sessions, isLoading: sessionsLoading } = useGetLessonSessionsQuery();

    const handleChange = (e) => {
        const { name, value } = e.target;
        const selectedSession = sessions?.data?.find(s => s.id === value);
        setSchoolYear(prev => ({
            ...prev,
            [name]: value,
            sessionName: selectedSession ? selectedSession.name : ''
        }));
    };

    const fetchData = useCallback(async () => {
        try {
        setLoadindData(true);
        const res = await api.getCalendars(
            admToken,
            '',
            10,
            1,
        );
        setLoadindData(false);
        } catch (error) {
        console.error("Error fetching data:", error);
        setLoadindData(false);
        }
    }, [admToken]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);
    
    const handleSubmit = async () => {
        setLoading(true);
        try {
            const payload = {
                sessionId: schoolYear.sessionId,
                sessionName: schoolYear.sessionName,
            }
            const res = await api.createCalendar(admToken, payload);
            if (res.status && res.statusCode === 2) {
                toast.success(res.message || "Calendar Successfully Added", {
                    autoClose: 4000,
                    position: toast.POSITION.BOTTOM_LEFT,
                });
                fetchData()
            } else {
                toast.error(res.message || "Failed to create calendar", {
                    autoClose: 4000,
                    position: toast.POSITION.BOTTOM_LEFT,
                });}
            handleCloseModal();
        } catch (error) {
            console.error("Error creating calendar:", error);
        } finally {
            setLoading(false);
        }
    };
  return (
    <ThemeProvider theme={theme}>
        <Box>
            <Box sx={{ my: 5, display:  "flex", justifyContent:"end" }}>
                <Button
                    onClick={handleOpenModal}
                    variant="contained"
                    sx={{
                    textTransform: "initial",
                    fontFamily: "Gilroy-Bold",
                    height: "50px",
                    px: 7,
                    py: 0.5,
                    }}
                >
                    Create Calendar
                </Button>
            </Box>
        <div className="ring-1 ring-[#691e78] rounded-xl ">
                <ThemeProvider theme={darkTheme}>
                    <Box sx={{ width: "100%" }}>
                        <Box>
                            <CalenderTable />
                        </Box>
                    </Box>
                </ThemeProvider>
        </div>
            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                <Box align="right" sx={{}}>
                    <IconButton onClick={handleCloseModal}>
                    <HighlightOffIcon />
                    </IconButton>
                </Box>
                <Box>
                    <Typography
                    variant="h4"
                    sx={{ textAlign: "center", mb: 2, fontFamily: "Gilroy-Medium" }}
                    >
                    Create Calender
                    </Typography>
                    <Divider />
                </Box>
                <Box p={3} sx={{ overflowY: "scroll", height: "450px" }}>
                    <Grid item sm={6} xs={12}>
                        <Box>
                            <InputLabel
                            sx={{
                                mb: 1.5,
                                mt: 1,
                                fontSize: "12px",
                                fontWeight: "bolder",
                                color: "#000",
                                fontFamily: "Gilroy-Medium",
                            }}
                            >
                            School Year
                            </InputLabel>
                            <FormControl fullWidth>
                            <Select
                                name="sessionId"
                                sx={{
                                fontFamily: "Gilroy-Regular",
                                border: "0.5px solid #671E78",
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                    border: "1px solid #671E78",
                                    },
                                },
                                }}
                                variant="outlined"
                                size="small"
                                value={schoolYear.sessionId}
                                onChange={handleChange}
                                disabled={sessionsLoading}
                            >
                                {sessionsLoading ? (
                                <MenuItem disabled>Loading session...</MenuItem>
                                ) : !sessions?.data || sessions.data.length === 0 ? (
                                <MenuItem disabled>No session available</MenuItem>
                                ) : (
                                sessions.data.map((session) => (
                                    <MenuItem
                                        sx={{ fontFamily: "Gilroy-Regular" }}
                                        value={session.id}
                                        key={session.id}
                                    >
                                        {session.name}
                                    </MenuItem>
                                ))
                                )}
                            </Select>
                            </FormControl>
                        </Box>
                    </Grid>
                    <Box mt={10}>
                        <Button
                            variant="contained"
                            fullWidth
                            sx={{ textTransform: "initial" }}
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? "Adding..." : "Add Calender"}
                        </Button>
                    </Box>
                </Box>
                </Box>
            </Modal>
        </Box>
    </ThemeProvider>
  );
};